import HTTP from '@/utils/http'
import notification from '@/utils/notification'
import { UserDomain } from '@/utils/consts'

export async function getContractors (projectId) {
  try {
    const response = await HTTP.get(`/project_contractors/${projectId}`)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err, `get project contractors error. projectId: ${projectId}`)
    return null
  }
}

export async function updateContractors (projectId, request, isTenantProject) {
  try {
    const response = await HTTP.put(`/project_contractors/${projectId}`,
      { ...request, domain: isTenantProject ? UserDomain.TMS : UserDomain.CMS })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err, `update project contractors error. projectId: ${projectId}`)
    throw err
  }
}

export async function inviteContractor (contractorId, isTenantProject) {
  try {
    const response = await HTTP.post(`/project_contractors/${contractorId}/invite`,
      { domain: isTenantProject ? UserDomain.TMS : UserDomain.CMS })
    notification.handleResponseAlert(response)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err, `inviteContractors project other contractors error. contractorId: ${contractorId}`)
    return null
  }
}
